import { getAgeTag } from '../../../utils'

export const formatDisplayName = (metricKey) => {
    const metricDisplayNames = {
        vo2Peak: 'vo2Peak',
        total_body_fat_am: 'Total Body % Fat (Age Ranked)',
        vat: 'VAT Area',
        legs_difference: 'Legs (Difference)',
        arms_difference: 'Arms (Difference)',
        almi: 'aLMI (Age Ranked)',
        isometric_press_asymmetry: 'Single Arm Isometric Press (Asymmetry)',
        isometric_press_total: 'Single Arm Isometric Press/BW Total',
        isometric_pull_total: 'Single Arm Isometric Pull/BW Total',
        isometric_pull_asymmetry:'Single Arm Isometric Pull (Asymmetry)',
        Sit_to_Stand: 'Sit to Stand',
        belt_squat_isometric_asymmetry: 'Isometric Belt Squat Asymmetry',
        cervical_lateral_flexion_left: 'Cervical Lateral Flexion (L)',
        cervical_lateral_flexion_right: 'Cervical Lateral Flexion (R)',
        multi_segment_flexion: 'Multi Segmental Flexion',
        sier_left: 'Shoulder Internal & External Range of Motion (L)',
        sier_right: 'Shoulder Internal & External Range of Motion (R)',
        single_leg_squat_depth_left: 'Single Leg Squat Depth (L)',
        single_leg_squat_depth_right: 'Single Leg Squat Depth (R)',
        peak_knee_flexion_asymmetry: 'Overhead Squat Peak Knee Flexion Asymmetry',
        peak_knee_flexion_left: 'Overhead Squat Peak Knee Flexion (L)',
        peak_knee_flexion_right: 'Overhead Squat Peak Knee Flexion (R)',
        combined_grip_strength: 'Grip Strength Total',
        grip_strength_asymmetry: 'Grip Strength Asymmetry',
        sit_to_stand_asymmetry: 'Sit to Stand Knee Flexion Asymmetry',
        isometric_belt_squat_peak_force: 'Isometric Belt Squat Peak Force',
        isometric_belt_squat_asymmetry: 'Isometric Belt Squat Asymmetry',
        cervical_lateral_flexion_asymmetry: 'Cervical Lateral Flexion Asymmetry',
        single_leg_squat_depth_asymmetry: 'Single Leg Squat Depth Asymmetry',
        quiet_stand_mean_force_asymmetry: 'Quiet Stand Mean Force Asymmetry',
        total_excursion_asymmetry: 'Total Excursion Asymmetry',
        single_leg_stance_left_total_time: 'Single Leg Stance (Left) Total Time',
        single_leg_stance_right_total_time: 'Single Leg Stance (Right) Total Time',
        tmt_a: 'TMT-A',
        tmt_b: 'TMT-B',
        bcs_age_ranked: 'BrainCheck Combined Scored (Age Ranked)',
        category_fluency: 'Category Fluency',
        letter_fluency: 'Letter Fluency',
        mean_force_asymmetry: 'Mean Force Asymmetry',
        total_excursion: 'Total Excursion',
        total_excursion_left: 'Total Excursion (Left)',
        total_excursion_right: 'Total Excursion (Right)',
        total_time_left: 'Total Time (Left)',
        total_time_right: 'Total Time (Right)'
    }

    if (metricDisplayNames[metricKey]) {
        return metricDisplayNames[metricKey]
    }

    return metricKey
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
}

export const getRangeByAgeAndGender = (ranges, person, ageScopes) => {
    const ageTag = getAgeTag(person.profile, ageScopes)

    return ranges.map((range) => {
        const scope = range[`${person.profile.gender}_age_scope`][ageTag]
        if (scope) {
            const [min, max, color] = scope
            return { name: range.name, min, max, color }
        }
        return null
    })
}
